import Vue from 'vue'
import VueI18n from 'vue-i18n'

import pl from './languages/pl'
import en from './languages/en'

Vue.use(VueI18n)

const LOCALES = ['pl', 'en']
const defaultLocale = LOCALES[0]
const messages = { pl, en }

const isValidLocale = locale => LOCALES.includes(locale)
const getLocale = () => {
  const savedLocale = window.localStorage.getItem('locale')
  return isValidLocale(savedLocale) ? savedLocale : defaultLocale
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: defaultLocale,
  messages
})

export default i18n
export { LOCALES, isValidLocale, defaultLocale, getLocale }



// WEBPACK FOOTER //
// ./src/locale/index.js